export const H5Fields = [
    { identifier: 'font-size-h5', type: 'input', field: 'font-size-h5' },
    { identifier: 'font-weight-h5', type: 'input', field: 'font-weight-h5' },
    { identifier: 'font-color-h5', type: 'input', field: 'font-color-h5' }
]
